import { createTrendsFeed } from './stores.js';
import { derived } from 'svelte/store';

import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import USHouseTrends from './components/USHouseTrends.svelte';

async function main() {
  const trendsFeed = await createTrendsFeed();

  const feed = derived(
    trendsFeed,
    ($feed) => $feed.data?.attributes?.house
  );

  const element = findElementByIdInShadowDom('trends-us-house-viz');

  if (element) {
    renderSvelteComponent(USHouseTrends, element, {
      feed,
    });
  }
}

main().catch(console.error);
